export default "__VITE_ASSET__733b2f27__"